import { useContext, useState } from "react";
import Input from "../../Input/Input";
import "./Order.css";
import mainApi from "../../../assets/api/MainApi";
import PromoCheckPopup from "../PromoCheckPopup/PromoCheckPopup";
import MiniPreloader from "../../MiniPreloader/MiniPreloader";
import { ConfigContext } from "../../../assets/contexts/configContext";

// import { BASKET } from '../../../assets/utils/constants';

export const Order = ({
  cart,
  handleNextStep,
  step,
  promo,
  setPromo,
  isPersonalValid,
  isPreloaderVisible,
  total,
  someNotInStock,
  preloader,
}) => {
  const {
    PRICE,
    ITEMS_PRICE,
    ITEMS_DISCOUNT,
    ITEMS_COUNT,
    PRODUCTS,
    PROMO_DISCOUNT,
    DELIVERY_PRICE,
    NOT_DELIVERABLE,
  } = total;
  // const total_price =

  const [popups, setPopups] = useState({
    promo: false,
  });

  function handleChange(e) {
    const input = e.target;
    let value = input.value;

    setPromo({
      isValid: false,
      value: value,
    });
  }

  const config = useContext(ConfigContext)
  const { initialConstants } = config
  const { CONSTANTS } = initialConstants
  const { MINIMAL_ORDER_AMOUNT = 0 } = CONSTANTS
  const { SHOP_ID_FOR_API, } = initialConstants

  function handleUsePromo() {
    mainApi
      .checkPromo({
        shop_id: SHOP_ID_FOR_API,
        code: promo.value,
      })
      .then((res) => {
        setPromo((prevValue) => ({
          ...prevValue,
          isValid: true,
          discount: res.discount,
        }));
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setPopups((prevValue) => ({
          ...prevValue,
          promo: true,
        }));
      });
  }

  const MINIMAL_PRICE_ERROR = MINIMAL_ORDER_AMOUNT && Number(MINIMAL_ORDER_AMOUNT) > 0 && Number(PRICE) < Number(MINIMAL_ORDER_AMOUNT)

  return (
    <div className="order">
      <h3 className="order__title">Your order</h3>
      <svg className="order__icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M14.1667 16.6667H15.625C15.8712 16.6667 16.115 16.6182 16.3425 16.5239C16.57 16.4297 16.7767 16.2916 16.9508 16.1175C17.1249 15.9434 17.263 15.7367 17.3573 15.5092C17.4515 15.2817 17.5 15.0379 17.5 14.7917V4.375C17.5 3.87772 17.3025 3.40081 16.9508 3.04917C16.5992 2.69754 16.1223 2.5 15.625 2.5H4.375C3.87772 2.5 3.40081 2.69754 3.04917 3.04917C2.69754 3.40081 2.5 3.87772 2.5 4.375V14.1667" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M13.3346 2.5V4.58333C13.3346 4.91485 13.2029 5.2328 12.9685 5.46722C12.7341 5.70164 12.4162 5.83333 12.0846 5.83333H7.91797C7.58645 5.83333 7.26851 5.70164 7.03409 5.46722C6.79966 5.2328 6.66797 4.91485 6.66797 4.58333V2.5" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M5 17.5H2.5" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M9.72143 17.2559L12.317 14.6602C12.4342 14.543 12.5 14.384 12.5 14.2183C12.5 14.0525 12.4342 13.8936 12.317 13.7764L11.2236 12.683C11.1064 12.5658 10.9475 12.5 10.7817 12.5C10.616 12.5 10.457 12.5658 10.3398 12.683L7.74409 15.2786C7.66671 15.3559 7.60532 15.4478 7.56344 15.5489C7.52156 15.65 7.5 15.7584 7.5 15.8678V17.2916C7.5 17.3469 7.52195 17.3999 7.56102 17.4389C7.60009 17.478 7.65308 17.5 7.70833 17.5H9.13215C9.24159 17.5 9.34996 17.4784 9.45107 17.4365C9.55218 17.3946 9.64405 17.3333 9.72143 17.2559Z" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      {!preloader ?
        !someNotInStock ?
          <div className="order__params">
            <div className="order__param">
              <h4 className="order__param-name">Products</h4>
              {/* <div className="order__param-line"></div> */}
              <h4 className="order__param-value">{ITEMS_COUNT}</h4>
            </div>
            <div className="order__param">
              <h4 className="order__param-name">For the amount</h4>
              {/* <div className="order__param-line"></div> */}
              <h4 className="order__param-value">
                {Number(ITEMS_PRICE).toLocaleString()}
              </h4>
            </div>
            {ITEMS_DISCOUNT > 0 ? (
              <div className="order__param">
                <h4 className="order__param-name">Discount</h4>
                <div className="order__param-line"></div>
                <h4 className="order__param-value">
                  -${Number(ITEMS_DISCOUNT).toLocaleString()}
                </h4>
              </div>
            ) : null}
            {promo.isValid && PROMO_DISCOUNT > 0 ? (
              <div className="order__param">
                <h4 className="order__param-name">
                  Promo-code (-{promo.discount}%)
                </h4>
                <div className="order__param-line"></div>
                <h4 className="order__param-value">
                  -${Number(PROMO_DISCOUNT).toLocaleString()}
                </h4>
              </div>
            ) : null}
            {DELIVERY_PRICE > 0 ? (
              <div className="order__param">
                <h4 className="order__param-name">Delivery price</h4>
                <div className="order__param-line"></div>
                <h4 className="order__param-value">
                  ${Number(DELIVERY_PRICE).toLocaleString()}
                </h4>
              </div>
            ) : null}

            {/* <div className="order__param">
                    <span className='order__param-name'>Доставка</span>
                    <div className="order__param-line"></div>
                    <span className='order__param-value'>{Number(DELIVERY_PRICE).toLocaleString()} ₽</span>
                </div> */}

            <div className="order__param order__param_type_total">
              <h4 className="order__param-name">Total:</h4>
              {/* <div className="order__param-line"></div> */}
              <h4 className="order__param-value">
                ${Number(PRICE).toLocaleString()}
              </h4>
            </div>
          </div>
          :
          <div className="order__params">
            <p className="order__param-name order__param-name_not-availible">Some products are unavailable.</p>
            <p className="order__param-name order__param-name_not-availible">Please remove them from the cart.</p>
          </div>
        :
        <div className="order__preloader">
          <MiniPreloader />
        </div>}

      <p className="order__hint"></p>
      {total.DELIVERY_TIME ? <p className="order__delivery-time">Approximate delivery time: <br /><b>{total.DELIVERY_TIME}</b></p> : null}
      {NOT_DELIVERABLE ? <p className="order__not-deliverable">Unfortunately, delivery to the specified address is not available.</p> : null}

      {
        !someNotInStock && !NOT_DELIVERABLE ?
          <div className="order__controls">
            <div className="order__promo">
              <Input
                label={"Promo-code"}
                value={promo.value}
                handleChange={handleChange}
                name={"promo_code"}
              // error={formValid.email}
              ></Input>
              <button
                className={`order__promo-button ${promo.value ? "" : "order__promo-button_inactive"
                  }`}
                onClick={handleUsePromo}
              >
                <p className="order__promo-button-text">Use</p>
              </button>
            </div>
            {/* <button className='order__btn order__btn_up' type='Button'>Применить промо-код</button> */}
            {MINIMAL_PRICE_ERROR ?
              <p className="order__minimal-order">Minimum order amount - ${Number(MINIMAL_ORDER_AMOUNT).toLocaleString()}</p>
              : null}
            <button
              className={`order__btn-submit 
                ${step === 0 && (!cart || cart.length === 0)
                  ? "order__btn-submit_inactive"
                  : ""
                }
                ${step === 1 && (!isPersonalValid || preloader)
                  ? "order__btn-submit_inactive"
                  : ""
                }
                ${MINIMAL_PRICE_ERROR ? 'order__btn-submit_inactive' : ''}
                ${isPreloaderVisible ? "order__btn-submit_inactive" : ""}
                `}
              type="button"
              onClick={handleNextStep}
            >
              {isPreloaderVisible ? (
                <MiniPreloader isLinkColor={true} />
              ) : step === 1 ? (
                <h3 className="order__btn-submit-text">Checkout</h3>
              ) : (
                <h3 className="order__btn-submit-text">Place Order</h3>
              )}
            </button>
          </div>
          :
          <div className="order__controls">
            {/* <button className='order__btn order__btn_up' type='Button'>Применить промо-код</button> */}
            <button
              type="button"
              onClick={() => {
                return
              }}
              className={`order__btn-submit order__btn-submit_inactive`}
            >
              <h3 className="order__btn-submit-text">Checkout</h3>
            </button>
          </div>}

      <PromoCheckPopup
        isOpen={popups.promo}
        promo={promo}
        popupName={"promo"}
        setOpen={setPopups}
      />
    </div>
  );
};
